function initializeEagle() {
  const root = document.querySelector('[data-e3-storefront]');
  if (!root || root.dataset.initialized) return;
  root.dataset.initialized = 'true';
  const filters = [...root.querySelectorAll('[data-e3-filter]')];
  const groups = [...root.querySelectorAll('[data-e3-group]')];
  const output = root.querySelector('[data-e3-result]');
  const applyFilter = (filter) => {
    const chosen = filters.find(button => button.dataset.e3Filter === filter) ? filter : 'all';
    filters.forEach(button => button.setAttribute('aria-pressed', String(button.dataset.e3Filter === chosen)));
    let count = 0;
    groups.forEach(group => {
      const cards = group.querySelectorAll('.e3-card').length;
      const show = cards > 0 && (chosen === 'all' || group.dataset.e3Group === chosen);
      group.hidden = !show;
      if (show) count += cards;
    });
    if (output) output.textContent = `${count} ${output.dataset.label || 'products'}`;
  };
  filters.forEach(button => button.addEventListener('click', () => {
    applyFilter(button.dataset.e3Filter);
    root.querySelector('#e3-products')?.scrollIntoView({ behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth', block: 'start' });
  }));
  document.querySelectorAll('[data-e3-jump]').forEach(link => {
    link.addEventListener('click', () => {
      applyFilter(link.dataset.e3Jump);
      const menu = link.closest('details');
      if (menu) menu.open = false;
    });
  });
  applyFilter('all');
}
if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initializeEagle);
else initializeEagle();
document.addEventListener('shopify:section:load', initializeEagle);
